export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/identity.js
// module id = 62
// module chunks = 0